var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"value":_vm.events_count > 0,"content":_vm.events_count,"color":"red","overlap":"","offset-x":"20","offset-y":"20"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.goToAgenda}},[_c('v-icon',[_vm._v("mdi-calendar")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }